(() => {
  const closeLabel = document.currentScript?.dataset.closeLabel;
  function update() {
    const close = document.getElementById('shopify-pc__prefs__header-close');
    if (close && closeLabel) close.setAttribute('aria-label', closeLabel);
    const dialog = document.getElementById('shopify-pc__prefs__dialog');
    if (!dialog || document.documentElement.lang.split('-')[0] !== 'de') return;
    const walker = document.createTreeWalker(dialog, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes('dir Werbung')) node.nodeValue = node.nodeValue.replace('dir Werbung', 'Ihnen Werbung');
    }
  }
  update();
  new MutationObserver(update).observe(document.body, {childList:true, subtree:true});
})();
